module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ofri Ilany\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Ofri Ilany is a postdoctoral fellow at the Polonsky Academy for Advanced Study at the Van Leer Jerusalem Institute and a lecturer at Tel Aviv University.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CwhlAa/tc-custom/9780253033864.jpg?1717895902624",
      "alt": "This image is the cover for the book In Search of the Hebrew People"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In Search of the Hebrew People\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A book that “could serve as an effective introduction to German history, biblical studies and modern nationalism, among other fields” ("), _c('i', [_vm._v("German History")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("As German scholars, poets, and theologians searched for the origins of the ancient Israelites, Ofri Ilany believes, they created a model for nationalism that drew legitimacy from the biblical idea of the Chosen People. In this broad exploration of eighteenth-century Hebraism, Ilany tells the story of the surprising role that this model played in discussions of ethnicity, literature, culture, and nationhood among the German-speaking intellectual elite."), _c('br'), _c('br'), _vm._v("He reveals the novel portrait they sketched of ancient Israel and how they tried to imitate the Hebrews while forging their own national consciousness. This sophisticated and lucid argument sheds new light on the myths, concepts, and political tools that formed the basis of modern German culture.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0